<template>
  <table-view
    size="small"
    :columns="columns"
    :data="list"
    :loading="loading"
    :pagination="pageData"
    :showSizeChanger="false"
    :showQuickJumper="false"
    @handlePagination="handlePagination"
    :scroll="SCROLL"
  >
    <template v-slot:insurance="{ tableRow }">
      <span>{{ tableRow.insurance | formatAmount }}</span>
    </template>
    <template v-slot:netAr="{ tableRow }">
      <span>{{ tableRow.netAr | formatAmount }}</span>
    </template>
  </table-view>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import { getPageInsCoverRate } from './api'

export default {
  name: 'InsuranceCoverage',
  data() {
    return {
      list: [],
      loading: false,
      pageData: {
        pageSize: 5,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      columns: [
        {
          title: '客户编码',
          dataIndex: 'code',
          width: 100,
        },
        {
          title: '客户名称',
          dataIndex: 'name',
          width: 200,
        },
        {
          title: '公司类型',
          dataIndex: 'type',
          width: 100,
        },
        {
          title: '保险金额(元)',
          dataIndex: 'insurance',
          scopedSlots: { customRender: 'insurance' },
          width: 150,
        },
        {
          title: 'Net AR(元)',
          dataIndex: 'netAr',
          scopedSlots: { customRender: 'netAr' },
          width: 150,
        },
        {
          title: '保险覆盖率',
          dataIndex: 'insCoverRate',
          width: 100,
        },
      ],
      SCROLL: { x: 500 },
    }
  },
  props: ['companyCode', 'companyType'],
  created() {},
  mounted() {
    this._getPageInsCoverRate()
  },
  methods: {
    async _getPageInsCoverRate() {
      if (this.loading) {
        return
      }
      this.loading = true
      const { current, pageSize } = this.pageData
      const params = {
        size: pageSize,
        current: current,
        companyCode: this.companyCode,
        companyType: this.companyType,
      }
      try {
        const {
          data: { total, records },
        } = await getPageInsCoverRate(params)
        this.pageData.total = total
        this.list = records.map(item => {
          item.id = item.code
          return item
        })
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    handlePagination(pagination) {
      const { current } = pagination
      this.pageData.current = current
      this._getPageInsCoverRate()
    },
  },
  components: {
    TableView,
  },
}
</script>

<style lang="less" scoped>
// /deep/ .ant-popover {
//   width: 70% !important;
// }
</style>
